function parseCounterValue(rawValue) {
  const authoredValue = (rawValue || "").trim();

  if (!authoredValue) {
    return null;
  }

  const normalizedValue = authoredValue.replace(/[\s,]+/g, "");

  if (!/^-?\d+(\.\d+)?$/.test(normalizedValue)) {
    return {
      authoredValue,
      shouldAnimate: false,
    };
  }

  const decimals = (normalizedValue.split(".")[1] || "").length;

  return {
    authoredValue,
    shouldAnimate: true,
    numericValue: Number.parseFloat(normalizedValue),
    decimals,
    useGrouping: authoredValue.includes(","),
  };
}

function formatCounterValue(value, counterConfig) {
  const { decimals, useGrouping } = counterConfig;

  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping,
  }).format(value);
}

// Function that actually does the counting
function countUp(targetEl, counterConfig, duration) {
  if (!targetEl || !counterConfig || !isFinite(counterConfig.numericValue)) return;

  const start = 0;
  const end = counterConfig.numericValue;
  const startTime = performance.now();
  const easeOutCubic = (t) => 1 - (1 - t) ** 3;

  const tick = (now) => {
    const t = Math.min(1, (now - startTime) / duration);
    const value = start + (end - start) * easeOutCubic(t);
    targetEl.textContent = formatCounterValue(value, counterConfig);

    if (t < 1) {
      requestAnimationFrame(tick);
    } else {
      targetEl.textContent = formatCounterValue(end, counterConfig);
    }
  };

  targetEl.textContent = formatCounterValue(0, counterConfig);
  requestAnimationFrame(tick);
}

// Code to determine if the counter is in the user's viewport
const counters = document.querySelectorAll(
  ".stat-columns-with-images .stat-counter",
);
const seen = new WeakSet(); // Used to automate "garbage collection" as code should only run once

if ("IntersectionObserver" in window) {
  const io = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target); // ensure it only runs once
          const targetEl = entry.target.querySelector("span.number");
          const counterConfig = parseCounterValue(
            entry.target.getAttribute("data-target-number"),
          );

          if (!targetEl || !counterConfig) {
            obs.unobserve(entry.target);
            return;
          }

          if (!counterConfig.shouldAnimate) {
            targetEl.textContent = counterConfig.authoredValue;
            entry.target.classList.add("is-static");
            obs.unobserve(entry.target);
            return;
          }

          countUp(targetEl, counterConfig, 1000);
          obs.unobserve(entry.target); // stop tracking this one
        }
      });
    },
    {
      threshold: 0.2, // ~20% visible before starting
      rootMargin: "0px 0px -5% 0px", // start a bit before counter is fully in view
    },
  );

  counters.forEach((el) => io.observe(el));
} else {
  // Fallback for very old browsers runs on page load
  counters.forEach((counter) => {
    const targetEl = counter.querySelector("span.number");
    const counterConfig = parseCounterValue(
      counter.getAttribute("data-target-number"),
    );

    if (!targetEl || !counterConfig) {
      return;
    }

    if (!counterConfig.shouldAnimate) {
      targetEl.textContent = counterConfig.authoredValue;
      counter.classList.add("is-static");
      return;
    }

    countUp(targetEl, counterConfig, 1000);
  });
}
